import { Box, Heading, Text, VStack, Icon } from '@chakra-ui/react';
import { FaQuoteLeft, FaQuoteRight } from 'react-icons/fa';

const BibleVerse = () => (
  <Box
    p={6}
    textAlign="center"
    bg="pastelBlue"
    color="white"
    boxShadow="softShadow"
    borderRadius="lg"
  >
    <Heading fontSize="2xl" mb={4} color="white">
      Favorite Bible Verse
    </Heading>

    <VStack spacing={6} align="center">
      <Icon as={FaQuoteLeft} boxSize={6} />
      <Text fontSize="lg" fontStyle="italic" maxW="600px">
        "Now may the God of hope fill you with all joy and peace as you believe
        so that you may overflow with hope by the power of the Holy Spirit."
      </Text>
      <Text fontSize="lg" fontWeight="bold">
        — Romans 15:13
      </Text>
      <Icon as={FaQuoteRight} boxSize={6} />
    </VStack>

    <Text mt={8} fontSize="md">
      This verse reminds me of the overflowing joy and peace that only faith in
      God can bring. I hope it inspires you as it has inspired me!
    </Text>
  </Box>
);

export default BibleVerse;
